import * as React from "react";
import {Product} from "../../model/product/Product.model";
import {hasConsultantLevelAccess} from "../../utils/sessionUtil";
import {useEffect} from "react";
import ProductApi from "../../api/ProductApi";

export interface IProductResearcherProps {
    product: Product;
}

export const ProductResearcher: React.FunctionComponent<IProductResearcherProps> = (props) => {
    const [leadEmail, setLeadEmail] = React.useState<string | null>(null);
    const [backupEmail, setBackupEmail] = React.useState<string | null>(null);

    useEffect(() => {
       if (hasConsultantLevelAccess()) {
           if (props.product.leadResearcher) {
               ProductApi.requestResearcherEmail(props.product.leadResearcher)
                   .then((response) => {
                       setLeadEmail(response ? response.trim() : "");
                   })
                   .catch(() => {
                       setLeadEmail("");
                   });
           } else {
               setLeadEmail("");
           }

           if (props.product.backupResearcher) {
               ProductApi.requestResearcherEmail(props.product.backupResearcher)
                   .then((response) => {
                       setBackupEmail(response ? response.trim() : "");
                   })
                   .catch(() => {
                       setLeadEmail("");
                   });
           } else {
               setBackupEmail("");
           }
       }
    }, []);

    const renderMailToLink = () => {
        if (leadEmail === null || backupEmail === null) {
            return null;
        }

        let mailTo = leadEmail;
        if (backupEmail !== "") {
            mailTo = mailTo === "" ? backupEmail : `${mailTo};${backupEmail}`;
        }

        if (mailTo === "") {
            return null;
        }

        const subject = `Inquiry regarding ${props.product.name}, Backstop Id - ${props.product.backstopId}`;
        return <span className="product-researcher__label">
            {/* eslint-disable-next-line react/forbid-dom-props */}
                <a href={`mailto:${mailTo}?subject=${encodeURIComponent(subject)}`} className="product-researcher__email-link">
                    Send an Inquiry
                </a>
            </span>;

    };

    return hasConsultantLevelAccess()
        ? <div className="product-researcher__container" data-testid="product-researcher__container">
            <span className="product-researcher__label">
                Lead Researcher:
                <span className="product-researcher__name" data-testid="product-researcher__lead-name">
                    {props.product.leadResearcher ? props.product.leadResearcher : "N/A"}
                </span>
            </span>
            <span className="product-researcher__label">
                Backup Researcher:
                <span className="product-researcher__name" data-testid="product-researcher__backup-name">
                    {props.product.backupResearcher ? props.product.backupResearcher : "N/A"}
                </span>
            </span>
            {renderMailToLink()}
        </div>
        : null;
};